import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CustomerModel }  from '../../app-lite/customers/models/customer';
import { SessionModel }   from '../../app-lite/sessions/models/session';
import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  template: require('./customer.actions.component.html')
})
export class CustomerActionsComponent {
  @Input() record: CustomerModel;

  @Output() onEditClick      : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onAddVehicleClick: EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onBookingClick   : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onInvoiceClick   : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onSMSClick       : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onEmailClick     : EventEmitter<CustomerModel> = new EventEmitter();
  @Output() onActivateClick  : EventEmitter<CustomerModel> = new EventEmitter();

  constructor (
    public sessionService: SessionService
  ) {}

  get session () : SessionModel { return this.sessionService.base(); }
}